module.exports = __webpack_public_path__ + "media/10.a45f81f2.mp3";